import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '@/i18n';
import { Globe, ChevronDown } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const LanguageSelector = ({ className = '', compact = false }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className={`w-full [&>svg]:hidden ${className}`}>
        <div className="flex items-center gap-1 sm:gap-2">
          <Globe className="w-3 h-3 sm:w-4 sm:h-4 text-[#76A686] flex-shrink-0" />
          <SelectValue>
            <span className="flex items-center gap-1">
              <span className="text-sm sm:text-base">{currentLanguage.flag}</span>
              {!compact && <span className="hidden sm:inline text-[#2D3748]">{currentLanguage.name}</span>}
            </span>
          </SelectValue>
          <ChevronDown className="w-3 h-3 sm:w-4 sm:h-4 text-[#76A686] flex-shrink-0" />
        </div>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
